// extracted by mini-css-extract-plugin
export default {"wrapper":"Edit_wrapper__INhMx","prompt":"Edit_prompt__FWDcF"};